<!-- App Top Block-->
<section id="app" class="app-page-top">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-8">
        <div class="app-text">
          <h3>Set Your Price For <br />Business Class Flights</h3>
          <p>
            The easiest and fastest way to get a quote and save up to 70% off
            business class flights. <br />Download the app now!
          </p>
        </div>
        <div class="button-block">
          <a
            href="https://itunes.apple.com/us/app/wholesale-flights/id1390982713?mt=8"
            target="_blank"
            class="app-button"
          ></a>
          <a
            href="https://play.google.com/store/apps/details?id=com.wholesaleflights.android"
            target="_blank"
            class="app-button-play"
          ></a>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4 d-none d-md-block">
        <img
                width="200" height="408.31"
                class="app-phone"
          src="{{ cdnPath }}/assets/img/iphone7@1x.png"
          alt=""
        />
      </div>
    </div>
  </div>
</section>
<app-service></app-service>
<!--<app-trustpilot-grid></app-trustpilot-grid>-->
